"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var raf = require("raf");
var utilities_1 = require("../utilities");
var page_header_1 = require("./page-header");
var table_1 = require("./table");
var lodash_1 = require("lodash");
var LOGGER = utilities_1.createLogger('scrolling-stage');
var ScrollingStage = /** @class */ (function () {
    function ScrollingStage(ngZone, cd, headerHeight) {
        this.tables = immutable_1.Map();
        this.previousScrollTop = 0;
        this._ngZone = ngZone;
        this._cd = cd;
        this._pageHeader = lodash_1.isNil(headerHeight)
            ? page_header_1.PageHeader.EMPTY
            : new page_header_1.PageHeader(headerHeight, ngZone, cd);
    }
    ScrollingStage.prototype.initScrolling = function (scrollSideEffect) {
        var _this = this;
        this._ngZone.runOutsideAngular(function () {
            var elem = _this.getScrollingElement();
            if (lodash_1.isNil(elem)) {
                LOGGER.warn('cannot find scrolling-stage');
                return;
            }
            elem.addEventListener('scroll', function (ev) {
                if (scrollSideEffect) {
                    scrollSideEffect(ev);
                }
                _this.scrollListener(ev);
            }, true);
        });
    };
    ScrollingStage.prototype.handleTableResize = function (tableKey, event, headerHeight, footerHeight) {
        var oldTable = this.tables.get(tableKey);
        var newFixable = event.element.nativeElement.getBoundingClientRect();
        this.tables = this.tables.set(tableKey, new table_1.Table(oldTable ? oldTable.tableTop : newFixable.top, newFixable.height, headerHeight, footerHeight, this._pageHeader.height, this._ngZone, this._cd));
    };
    ScrollingStage.prototype.getTable = function (tableKey) {
        return this.tables.get(tableKey);
    };
    ScrollingStage.prototype.destroyScrolling = function () {
        var _this = this;
        var elem = this.getScrollingElement();
        if (lodash_1.isNil(elem)) {
            LOGGER.warn('cannot find scrolling-stage');
            return;
        }
        elem.removeEventListener('scroll', function (ev) { return _this.scrollListener(ev); });
    };
    ScrollingStage.prototype.destroyScrollingIfExists = function () {
        var _this = this;
        var elem = this.getScrollingElement();
        if (skynet_store_utilities_1.notNil(elem)) {
            elem.removeEventListener('scroll', function (ev) { return _this.scrollListener(ev); });
        }
    };
    Object.defineProperty(ScrollingStage.prototype, "pageHeader", {
        get: function () {
            return this._pageHeader;
        },
        enumerable: true,
        configurable: true
    });
    ScrollingStage.prototype.scrollListener = function (event) {
        var _this = this;
        if (!event.target.className.startsWith('resize-sensor')) {
            var scrollTop_1 = event.target.scrollTop;
            var scrollBy_1 = scrollTop_1 - this.previousScrollTop;
            this.previousScrollTop = scrollTop_1;
            raf(function () {
                _this._pageHeader.scroll(scrollBy_1);
                scrollTop_1 +=
                    _this._pageHeader.height + _this._pageHeader.transition;
                _this.tables.forEach(function (value) { return value.scroll(scrollBy_1, scrollTop_1); });
            });
        }
    };
    ScrollingStage.prototype.getScrollingElement = function () {
        return document.getElementsByClassName('scrolling-stage').item(0);
    };
    return ScrollingStage;
}());
exports.ScrollingStage = ScrollingStage;
//# sourceMappingURL=scrolling-stage.js.map